import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContratoDetalharComponent } from './contrato-detalhar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: ContratoDetalharComponent }
    ])],
    exports: [RouterModule]
})
export class ContratoDetalharRoutingModule { }
